import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V7H17V16ZM10 14C9.72386 14 9.5 14.2239 9.5 14.5C9.5 14.7761 9.72386 15 10 15C10.2761 15 10.5 14.7761 10.5 14.5C10.5 14.2239 10.2761 14 10 14ZM10 9C9.72386 9 9.5 9.22386 9.5 9.5V12.5C9.5 12.7761 9.72386 13 10 13C10.2761 13 10.5 12.7761 10.5 12.5V9.5C10.5 9.22386 10.2761 9 10 9ZM14 2C14.5523 2 15 2.44772 15 3H16C16.5523 3 17 3.44772 17 4V6H3V4C3 3.44772 3.44772 3 4 3H5C5 2.44772 5.44772 2 6 2C6.55228 2 7 2.44772 7 3H13C13 2.44772 13.4477 2 14 2Z"
      fill="#F2994A"
    />
  </svg>
);
